module.exports = __webpack_public_path__ + "assets/img/b444-tf.svg";